<template>
	<section class=knighthood-page>
		<h2 class="level-one-heading mb-5">Knighthood</h2>
		<hr>
		<p>
			Utöver vårt levelsystem med tillhörande förmåner dubbar vi numera även våra tappraste kunder varje år till Webhallen-riddare! Utmärkelsen delas ut till de kunder som oavsett medlemsnivå uppnått årets högt ställda kriterier. Knighthood-symbolen syns under året tillsammans med ditt användarnamn på din profilsida och i samband med att du syns vid till exempel. recensioner eller frågor & svar.
		</p>
		<template>
			<img :src="imageSource" alt="kategoribild">
		</template>
		<h3 class="sub-header mb-5 mt-5">Förutom utmärkelsen visar vi självklart även en uppskattning för
			dina hedervärda insatser med ett par förmåner!</h3>
		<ul>
			<li>En stolt achievement till din samling, värde 20 000 XP</li>
			<li>Ett par hemliga give-aways och unika erbjudanden under året</li>
			<li>En och annan tävling och överraskning under årets gång :) </li>
		</ul>
		<div class="community-quest-section">
			<h3>Knighthood Community Quest</h3>
			<p class="community-quest-info">I årets Knigthood Community Quest ska alla aspiranter tillsammans genom bildledtrådar försöka lista ut vilken butik de är ifrån. Gå med i vår <a href="https://discord.gg/webhallen-359645092254056448">Discord</a> och håll dig uppdaterad i "Community Quest 2025"-kanalen. Där kan du även bidra och se bilderna när de läggs ut.</p>

			<a-link
				:to="communityPath"
				buttonStyle="primary">
					Läs mer här
			</a-link>
		</div>
		<template v-if="knighthoodGoals.length">
			<h3 class="sub-header mb-5">Din progress för Webhallen Knighthood</h3>
			<p>
				<i>(Det kan ta upp till 12h för din progress att uppdateras i våra system)</i>
			</p>
			<p>
				{{ tk('TEXT') }}
			</p>
			<div class="knighthood-card-row">
				<knighthood-card v-for="goal in knighthoodGoals" :key="goal.id" :goal="goal" />
			</div>
		</template>
	</section>
</template>

<script>
import waja from 'waja';
import { mapState } from 'vuex';
import store from 'datastore';
import { convertToCdnUrl, standardRoute } from 'utils';
import i18n, { t } from 'datastore/i18n';

export default {
	store,
	data() {
		return {
			knighthoodGoals: [],
			imageSource: "/img/member/knighthood/knighthood23-banner.svg",
		};
	},
	computed: {
		...mapState({
			currentUser: state => state.user,
		}),
		communityPath () {
			return standardRoute('campaign',{ id:  10665, name: 'Community Quest!'});
		},
	},
	mounted() {
		this.loadKnighthoodGoals();
	},
	methods: {
		tk: t.prefix('KNIGHTHOODINFO'),
		convertToCdnUrl,

		loadKnighthoodGoals () {
			this.knighthoodGoals = [];

			const req = waja.get('user/me/knighthood?r');

			req.on('success', res => {
				this.knighthoodGoals = res.data;
			}).on('error', err => {
				console.error(err);
			}).go();
		},
	},
};
</script>
